<template>
  <div class="app">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col v-for="item in 5" :key="item">
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 5" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <v-skeleton-loader class="mx-auto" type="image" max-width="500" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <v-row dense>
        <v-col cols="3">
          <v-text-field
            dense
            v-model="form.acao.description"
            :counter="35"
            label="Descrição"
            :error-messages="descriptionErrors"
            @input="$v.form.acao.description.$touch()"
            @blur="$v.form.acao.description.$touch()"
          />
        </v-col>
        <v-col offset="1" cols="2">
          <v-switch dense v-model="form.active" label="Ativo" />
        </v-col>
        <v-col cols="3" align-self="center">
          <v-switch dense v-model="form.acao.identifyOperator" label="Identificar Operador" />
        </v-col>
      </v-row>
      <v-row justify="center" class="text-center">
        <v-col>
          <v-switch dense v-model="form.acao.record" label="Gravar" />
        </v-col>
        <v-col>
          <v-switch dense v-model="form.acao.continuar" label="Executar Próxima Ação Válida" />
        </v-col>
        <v-col>
          <v-switch dense v-model="form.acao.origemTransfere" label="Transferência na Origem" />
        </v-col>
        <v-col>
          <v-switch dense v-model="form.acao.destinoTransfere" label="Transferência no Destino" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-row>
            <v-col>
              <v-text-field
                dense
                v-model="form.regexVisualOrigem"
                :error-messages="regexVisualOrigemErrors"
                :counter="20"
                label="Expressão Origem"
                @input="
                  $v.form.regexVisualOrigem.$touch()
                  form.regexVisualOrigem = $event.trim()
                "
                @blur="$v.form.regexVisualOrigem.$touch()"
              />
            </v-col>
            <v-col>
              <v-text-field
                dense
                v-model="form.regexVisualDestino"
                :error-messages="regexVisualDestinoErrors"
                :counter="20"
                label="Expressão Destino"
                @input="
                  $v.form.regexVisualDestino.$touch()
                  form.regexVisualDestino = $event.trim()
                "
                @blur="$v.form.regexVisualDestino.$touch()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                dense
                v-model="form.alliasRegexOrigem"
                label="Grupos de Expressões Origem"
                :items="alliasRegexOrigem"
              />
            </v-col>
            <v-col>
              <v-select
                dense
                v-model="form.alliasRegexDestino"
                label="Grupos de Expressões Destino"
                :items="alliasRegexDestino"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-row>
            <v-col>
              <v-select
                dense
                v-model="form.acao.centroDeCusto"
                :error-messages="centroDeCustoErrors"
                :items="centroDeCusto"
                label="Centro de Custo"
                @input="$v.form.acao.centroDeCusto.$touch()"
                @blur="$v.form.acao.centroDeCusto.$touch()"
              />
            </v-col>
            <v-col>
              <v-text-field
                dense
                v-model="form.acao.tempo"
                :error-messages="tempoErrors"
                :counter="3"
                label="Tempo Discagem"
                @input="$v.form.acao.tempo.$touch()"
                @blur="$v.form.acao.tempo.$touch()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                dense
                v-model="form.acao.grupo_id"
                :items="gruposAtendimento"
                :error-messages="grupoErrors"
                label="Grupo de Atendimento"
                @input="$v.form.acao.grupo_id.$touch()"
                @blur="$v.form.acao.grupo_id.$touch()"
              />
            </v-col>
            <v-col>
              <v-select dense multiple v-model="form.acao.tag" :items="tags" label="Tags">
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.text }}</span>
                  <v-chip v-if="index === 1" small>
                    <span class="caption"> (+{{ form.acao.tag.length - 1 }}) </span>
                  </v-chip>
                </template>
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="toggleTags">
                    <v-list-item-action>
                      <v-icon :color="form.acao.tag.length > 0 ? 'indigo darken-4' : ''">
                        {{ iconTags }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        Selecionar Todas
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2" />
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="5">
          <v-card color="background">
            <v-toolbar dense dark color="primary">
              <v-col cols="12">Alterar origem</v-col>
            </v-toolbar>

            <v-divider></v-divider>
            <div class="ma-4">
              <v-row>
                <v-col cols="4">
                  <v-text-field
                    dense
                    v-model="form.acao.tamanhoPrefixoOrigem"
                    :error-messages="tamanhoPrefixoOrigemErrors"
                    type="number"
                    label="Cortar no Dígito"
                    @input="$v.form.acao.tamanhoPrefixoOrigem.$touch()"
                    @blur="$v.form.acao.tamanhoPrefixoOrigem.$touch()"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    dense
                    v-model="form.acao.alterarOrigemPara"
                    :error-messages="alterarOrigemParaErrors"
                    label="Alterar Para"
                    @input="
                      form.acao.alterarOrigemPara = $event.trim()
                      $v.form.acao.alterarOrigemPara.$touch()
                    "
                    @blur="$v.form.acao.alterarOrigemPara.$touch()"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    dense
                    v-model="form.acao.prefixoOrigem"
                    :error-messages="prefixoOrigemErrors"
                    label="Prefixo"
                    @input="
                      form.acao.prefixoOrigem = $event.trim()
                      $v.form.acao.prefixoOrigem.$touch()
                    "
                    @blur="$v.form.acao.prefixoOrigem.$touch()"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    dense
                    v-model="form.acao.retiradaOrigem"
                    :error-messages="retiradaOrigemErrors"
                    label="Retirar final"
                    type="number"
                    @input="$v.form.acao.retiradaOrigem.$touch()"
                    @blur="$v.form.acao.retiradaOrigem.$touch()"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    dense
                    v-model="form.acao.addFinalOrigem"
                    :error-messages="addFinalOrigemErrors"
                    type="number"
                    label="Inserir final"
                    @input="$v.form.acao.addFinalOrigem.$touch()"
                    @blur="$v.form.acao.addFinalOrigem.$touch()"
                  />
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'

import rotasStore from '../../../../store'

import { rotasMixin } from '../_mixins/rotasMixins'
import { validateData, validateComputed } from '../_validates/validateDiscarGrupo'

export default {
  name: 'DiscarGrupoAtendimento',
  mixins: [validationMixin, rotasMixin],
  data: () => ({
    form: {
      description: 'DISCAR PARA GRUPO DE ATENDIMENTO',
      regexVisualOrigem: '',
      regexVisualDestino: '',
      alliasRegexOrigem: '',
      alliasRegexDestino: '',
      active: true,
      acao: {
        description: 'DISCAR PARA GRUPO DE ATENDIMENTO',
        class: 'Modules\\Agi\\Entities\\acoes\\DiscarGrupo',
        centroDeCusto: '',
        tag: [],
        record: true,
        identifyOperator: false,
        tamanhoPrefixoOrigem: 0,
        alterarOrigemPara: '',
        prefixoOrigem: '',
        sufixoOrigem: '',
        retiradaOrigem: '',
        addFinalOrigem: '',
        tempo: '90',
        origemTransfere: true,
        destinoTransfere: true,
        continuar: false,
        grupo_id: '',
      },
    },
    gruposAtendimento: [],
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('discarGrupoAtendimentoAcoesRotasModulePABXStore', ['getGruposAtendimento']),
    ...validateComputed,
  },

  async created() {
    registerVuexModule(this.$store, 'discarGrupoAtendimentoAcoesRotasModulePABXStore', rotasStore)

    await Promise.all([
      this.listarCentroDeCustos(),
      this.listarGruposAtendimento(),
      this.listarRegex(),
      this.listarTags(),
    ])

    this.getItemsSelectCentroDeCusto()
    this.getItemsSelectRegexOrigemEDestino()
    this.getItemsSelectTags()

    this.gruposAtendimento = this.getGruposAtendimento.map(grupoAtendimento => ({
      value: grupoAtendimento._id,
      text: grupoAtendimento.description,
    }))

    this.makeFormulario()

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('discarGrupoAtendimentoAcoesRotasModulePABXStore', ['listarGruposAtendimento']),
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
